/* AuditPolicyExplorerLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");
// const policyPerms = [
//     "auditManageLevel1",
//     "auditManageLevel2",
//     "auditManageLevel3"
// ];
class AuditPolicyExplorerLmrbComponent extends GameEditor {
    constructor(logger, di, editorLayout, userSession, DeviceEntity, solutionManager) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._DeviceEntityDef = DeviceEntity;
        this._solutionManager = solutionManager;
        this._openEditorFromUrl = false;
        this._filterFromUrl = false;
        this._updateNameSpaces();

        this._registerDeviceExplorerListeners();

        const superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer._rootElem.classList.add("audit-policy-explorer-lmrb");

                return this.whenGameEditorStorageIsReady().then(() => {
                    const otherParams = _.get(Steve.router.getRouteDetails(), "rd", "");
                    if (otherParams.openEditor || !_.isEmpty(otherParams.selection)) {
                        this._openEditorFromUrl = {
                            open: otherParams.openEditor || false,
                            selectedIds: otherParams.selection,
                        };
                    }
                    if (!_.isEmpty(otherParams.filter) || !_.isUndefined(otherParams.filter)) {
                        this._filterFromUrl = true;
                    }

                    if (this._LMRBLayout.state.bottom.dockletClicked === true) {
                        this._gameEditorData.setData(
                            this._LMRBLayout.state.bottom._state.openedPartId,
                            "currentExplorerView"
                        );
                        this._LMRBLayout.state.bottom.dockletClicked = undefined;
                    }

                    const currentView = this._whereToRedirect();
                    this._switchSolution(currentView);

                    return;
                });
            });
        };
    }

    _switchSolution(view = "") {
        let currentExplorerView = this._gameEditorData.getData("currentExplorerView");
        if (!_.isEmpty(view)) {
            currentExplorerView = view;
        }

        this._gameEditorData.setData(currentExplorerView, "currentExplorerViewTemp");

        if (
            currentExplorerView &&
            currentExplorerView === Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB
        ) {
            this.openLMRBExplorer(Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB);
        } else {
            this.openLMRBExplorer(Registrations.AUDIT_POLICY_EXPLORER_LMRB);
            this._cabinetCmpnt.selectView(Registrations.AUDIT_POLICY_EXPLORER_GRID);
        }

        return;
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(solutionDefinition, "auditPolicyExplorer.viewNamespaces", []);
        let gameEditorActions = _.get(
            solutionDefinition,
            "auditPolicyExplorer.actionNamespaces",
            []
        );
        // const authActions = this._userSession.authorizedActions;
        // const availablePolicyPerms = authActions.filter(action => {
        //     if (policyPerms.indexOf(action) >= 0) {
        //         return true;
        //     }
        //     return false;
        // });
        // if (availablePolicyPerms.length <= 0) {
        //     gameEditorActions = gameEditorActions.filter(action => action !== Registrations.AUDIT_POLICY_EXPLORER_ACTION_CREATE);
        // }
        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _registerDeviceExplorerListeners() {
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );
        this._cabinetCmpnt.on(
            "ExplorerChanged",
            (this._onExplorerChanged = this._onExplorerChanged.bind(this))
        );
        Steve.router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = _.throttle(this._onRouteInfoChanged.bind(this), 500))
        );
    }

    _unregisterDeviceExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
        if (this._cabinetCmpnt) {
            this._cabinetCmpnt.removeListener("ExplorerChanged", this._onExplorerChanged);
        }
        if (Steve.router) {
            Steve.router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
        }
    }

    launchAuditEditor(editorState, launchOpts) {
        const policyId = launchOpts.id;
        const policesIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = policesIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    policyId,
                });
                return this._editorLayout.launchEditor(
                    editorState,
                    Registrations.AUDIT_POLICY_EDITOR,
                    launchOpts
                );
            });
    }

    updateFilter(filterString) {
        if (_.isEmpty(filterString)) {
            this._reestablishFeed();
        } else {
            this._reestablishFeed(filterString);
        }
    }

    generateHash(stringToHash) {
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToHash);

        return window.crypto.subtle.digest("SHA-256", data).then(hexString);

        function hexString(buffer) {
            const byteArray = new Uint8Array(buffer);
            const hexCodes = [...byteArray].map((value) => {
                const hexCode = Number(value).toString(16);
                return hexCode.padStart(2, "0");
            });
            return hexCodes.join("");
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    shutdown() {
        let shutdowns = [];
        return Promise.all(shutdowns).then(
            () => {
                this._unregisterDeviceExplorerListeners();
                this._userSession = undefined;
                this._editorLayout = undefined;
                this._DeviceEntityDef = undefined;
                this._filterFromUrl = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "DeviceExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSolutionChanged(/*newActiveSolution*/) {
        this.shutdown();
    }

    _onOrganizationChange(newOrg, oldOrg) {
        this._unregisterDeviceExplorerListeners();
        if (!_.isUndefined(newOrg) && !_.isUndefined(oldOrg) && newOrg.id !== oldOrg.id) {
            this.renderer.render().then(() => {
                this._registerDeviceExplorerListeners();
            });
        }
    }

    _onExplorerChanged() {
        this.shutdown();
    }

    _onRouteInfoChanged() {
        if (event && event.oldURL !== event.newURL) {
            const currentView = this._whereToRedirect();
            if (
                currentView &&
                this._gameEditorData.getData("currentExplorerViewTemp") !== currentView
            ) {
                this._gameEditorData.setData(currentView, "currentExplorerViewTemp");
                this._gameEditorData.setData(currentView, "currentExplorerView");
                this._cabinetCmpnt.emit("ExplorerChanged");
                this.openLMRBExplorer(currentView);
            }
        }
    }

    _whereToRedirect() {
        let currentView = "";
        if (_.get(Steve.router.getRouteDetails(), "exp", false)) {
            let currentViewName = _.get(Steve.router.getRouteDetails(), "exp", "");
            switch (currentViewName) {
                case "device":
                    currentView = Registrations.CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB;
                    break;
                case "audit":
                    currentView = Registrations.AUDIT_POLICY_EXPLORER_LMRB;
                    break;
            }

            // this._gameEditorData.setData(currentView, "currentExplorerView");
            // Steve.router.rollups({app: 'GameConsole', s: 'GameCenter', sln: 'OsManager'});
        }

        return currentView;
    }
}

module.exports = AuditPolicyExplorerLmrbComponent;

AuditPolicyExplorerLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.entities.Device",
    "$teve.solutionsManager",
];
AuditPolicyExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
AuditPolicyExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
AuditPolicyExplorerLmrbComponent.$iconRepoName = "configdrift.audit_policy_explorer";
AuditPolicyExplorerLmrbComponent.$openedByDefault = true;
AuditPolicyExplorerLmrbComponent.$displayName = "Audit Policy Explorer";
